import MyOfficeAssignmentAdmin from '../Contents/Operations/Assignments/MyOfficeAssignment/MyOfficeAssignmentAdmin';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import TabListTableCellWidthEnum from '../Enums/TabListTableCellWidthEnum';
import React from 'react';

export default class MyOfficeAssignmentDetailItem {
  constructor(item) {
    if (item === undefined) {
      this.CompletedDate = '';
      this.ClientName = '';
      this.ProjectName = '';
      this.ProjectId = '';
      this.ProjectOfficeName = '';
      this.NumReadyForInvoicing = '';
      this.NumNotReadyForInvoicing = '';
      this.NumPendingPe = '';
    } else {
      this.CompletedDate = item.completedDate;
      this.ClientName = item.clientName;
      this.ProjectName = item.projectName;
      this.ProjectId = item.projectId;
      this.ProjectOfficeName = item.projectOfficeName;
      this.NumReadyForInvoicing = item.numReadyForInvoicing;
      this.NumNotReadyForInvoicing = item.numNotReadyForInvoicing;
      this.NumPendingPe = item.numPendingPe;
    }
  }

  static NameOfTheIdField() {
    return 'ProjectId';
  }

  static nameOfTheItemDetailList(item) {
    if (item) return <span>Project Assignments - {item.ProjectId}</span>;
    return 'Project Assignments';
  }

  static MoneyFields = [];

  static Currency() {
    return '';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return '';
  }

  static DateFields = [];

  static FieldsToShowInListTable = [
    {
      tabName: 'Ready For Invoicing',
      tabLabel: 'Ready For Invoicing',
      icon: 'fa-brands fa-grav fa-2x',
      data: [
        {
          name: (item) => (
            <MyOfficeAssignmentAdmin
              type={'ready for invoicing'}
              projectId={item.ProjectId}
              completedDate={item.CompletedDate}
            />
          ),
          label: 'Ready For Invoicing',
          width: TabListTableCellWidthEnum.Table,
        },
      ],
    },
    {
      tabName: 'Not Ready For Invoicing',
      tabLabel: 'Not Ready For Invoicing',
      icon: 'fa-brands fa-grav fa-2x',
      data: [
        {
          name: (item) => (
            <MyOfficeAssignmentAdmin
              type={'not ready for invoicing'}
              projectId={item.ProjectId}
              completedDate={item.CompletedDate}
            />
          ),
          label: 'Not Ready For Invoicing',
          width: TabListTableCellWidthEnum.Table,
        },
      ],
    },
    {
      tabName: 'Pending PE',
      tabLabel: 'Pending PE',
      icon: 'fa-brands fa-grav fa-2x',
      data: [
        {
          name: (item) => (
            <MyOfficeAssignmentAdmin
              type={'pending pe'}
              projectId={item.ProjectId}
              completedDate={item.CompletedDate}
            />
          ),
          label: 'Pending PE',
          width: TabListTableCellWidthEnum.Table,
        },
      ],
    },
    {
      tabName: 'All Assignments',
      tabLabel: 'All Assignments',
      icon: 'fa-brands fa-grav fa-2x',
      data: [
        {
          name: (item) => (
            <MyOfficeAssignmentAdmin
              type={'all assignments'}
              projectId={item.ProjectId}
              completedDate={item.CompletedDate}
            />
          ),
          label: 'All Assignments',
          width: TabListTableCellWidthEnum.Table,
        },
      ],
    },
  ];

  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Completed Date',
        orderById: 'CompletedDate',
        data: 'CompletedDate',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Client',
        orderById: 'ClientName',
        data: 'ClientName',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Project',
        orderById: 'ProjectName',
        data: 'ProjectName',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Project ID',
        orderById: 'ProjectId',
        data: 'ProjectId',
        type: FieldTypesEnum.DataFieldWithDetails,
      },
      {
        label: "Project's Office",
        orderById: 'ProjectOfficeName',
        data: 'ProjectOfficeName',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Ready For Invoicing',
        orderById: 'NumReadyForInvoicing',
        data: 'NumReadyForInvoicing',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Not Ready For Invoicing',
        orderById: 'NumNotReadyForInvoicing',
        data: 'NumNotReadyForInvoicing',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Pending PE',
        orderById: 'NumPendingPe',
        data: 'NumPendingPe',
        type: FieldTypesEnum.PureDataField,
      },
    ];
  }
}
